import ClientsGridRowWrapper from '../ClientsGridRowWrapper';

import { formatPhoneNumber } from '@american-autonomy/ag-ui';

import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const ClientsGridRow = ({
    contactName,
    email,
    id,
    name,
    phone,
    ref,
    style,
    testId = TEST_ID
}: Props) => {
    const { clientDetailsPage } = usePageRoutes();

    return (
        <ClientsGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={clientDetailsPage(id)} />

            <TableLink
                className={styles.tableLink}
                text={contactName ?? '-'}
                to={clientDetailsPage(id)}
            />

            <TableLink
                className={styles.tableLink}
                text={email ?? '-'}
                to={clientDetailsPage(id)}
            />

            <TableLink
                className={styles.tableLink}
                text={formatPhoneNumber(phone) ?? '-'}
                to={clientDetailsPage(id)}
            />
        </ClientsGridRowWrapper>
    );
};

export default ClientsGridRow;
